export default function () {
    return {
        sponsors: []
    }
}